/* eslint-disable react/prop-types */
import React from 'react';
import { useAppContext } from '../../../saas/AppConfigWrapper';

export default function AppFlightLogo({
  carrier,
  className = '',
  width = '',
  height = '',
  style = {},
}) {
  const { appConfig } = useAppContext();
  return (
    <img
      src={`${appConfig.appFlightCarrierImg}${carrier}.jpg`}
      alt={carrier}
      width={width}
      height={height}
      className={className}
      style={style}
    />
  );
}
